<ul class:bx--side-nav__items="{true}">
  <slot />
</ul>
